module.exports = __webpack_public_path__ + "static/img/pic_szh_cgal_gc_bg.e44ae9ed.png";